import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addAuthorisedContact } from '../services/authorisedContacts';
import type { AddAuthorisedContactInput } from '../types/authorisedContacts.types';
import { agreementKeys } from './agreementKeys';

export function useAddAuthorisedContactMutation(id: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input: AddAuthorisedContactInput) => addAuthorisedContact(id, input),
        /** A contact change appends a history event too, so both feeds go stale at once. */
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.authorisedContacts(id) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(id) });
        },
    });
}
